"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ShieldStrike = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M20.501 16.259A15.512 15.512 0 0 0 22 9.606V6a1 1 0 0 0-.758-.97l-1.69-.423a15 15 0 0 1-4.08-1.69l-2.957-1.774a1 1 0 0 0-1.03 0L8.527 2.918c-.288.172-.58.335-.879.488l1.477 1.477c.145-.082.289-.165.431-.25L12 3.166l2.444 1.467a17 17 0 0 0 4.623 1.915L20 6.78v2.825c0 1.77-.348 3.515-1.015 5.137l1.516 1.516z", fill: fill || 'currentColor' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m3.444 4.858-.687.172A1 1 0 0 0 2 6v3.606c0 3.063.907 6.056 2.605 8.605a10.07 10.07 0 0 0 4.64 3.764l2.384.953a1 1 0 0 0 .742 0l2.385-.953a10.069 10.069 0 0 0 3.477-2.328l2.06 2.06 1.414-1.414-18-18-1.414 1.414 1.151 1.151zm1.649 1.649-.16.04L4 6.782v2.825c0 2.668.79 5.276 2.27 7.495a8.07 8.07 0 0 0 3.717 3.017l2.013.805 2.013-.805a8.071 8.071 0 0 0 2.806-1.885L5.093 6.507z", fill: fill || 'currentColor' })));
};
exports.default = ShieldStrike;
